import { Grid, IconButton, Select, MenuItem } from "@material-ui/core";
import { createStyles, withStyles } from '@material-ui/core/styles';
import React from "react";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { setMonth, getMonth, setYear, getYear } from "date-fns";
var styles = createStyles({
    iconContainer: {
        padding: 5
    },
    icon: {
        padding: 10,
        "&:hover": {
            background: "none"
        }
    }
});
var MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
];
var generateYears = function (relativeTo, count) {
    var half = Math.floor(count / 2);
    return Array(count)
        .fill(0)
        .map(function (_, i) { return relativeTo.getFullYear() - half + i; }); // TODO: make part of the state
};
var Header = function (_a) {
    var date = _a.date, classes = _a.classes, setDate = _a.setDate, nextDisabled = _a.nextDisabled, prevDisabled = _a.prevDisabled, onClickNext = _a.onClickNext, onClickPrevious = _a.onClickPrevious, _b = _a.months, months = _b === void 0 ? MONTHS : _b;
    var handleMonthChange = function (event) {
        setDate(setMonth(date, parseInt(event.target.value)));
    };
    var handleYearChange = function (event) {
        setDate(setYear(date, parseInt(event.target.value)));
    };
    return (React.createElement(Grid, { container: true, justify: "space-between", alignItems: "center" },
        React.createElement(Grid, { item: true, className: classes.iconContainer },
            React.createElement(IconButton, { className: classes.icon, disabled: prevDisabled, onClick: onClickPrevious },
                React.createElement(ChevronLeft, { color: prevDisabled ? "disabled" : "action" }))),
        React.createElement(Grid, { item: true },
            React.createElement(Select, { value: getMonth(date), onChange: handleMonthChange, MenuProps: { disablePortal: true } }, months.map(function (month, idx) { return (React.createElement(MenuItem, { key: month, value: idx }, month)); }))),
        React.createElement(Grid, { item: true },
            React.createElement(Select, { value: getYear(date), onChange: handleYearChange, MenuProps: { disablePortal: true } }, generateYears(date, 30).map(function (year) { return (React.createElement(MenuItem, { key: year, value: year }, year)); }))),
        React.createElement(Grid, { item: true, className: classes.iconContainer },
            React.createElement(IconButton, { className: classes.icon, disabled: nextDisabled, onClick: onClickNext },
                React.createElement(ChevronRight, { color: nextDisabled ? "disabled" : "action" })))));
};
export default withStyles(styles)(Header);
//# sourceMappingURL=Header.js.map